module.exports = __webpack_public_path__ + "static/media/cuaderno.11bdfc96.png";